/**
 * @generated SignedSource<<7c585bba896ddcc6a6a71318e1dc90ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee$data = {
  readonly name: string;
  readonly " $fragmentType": "WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee";
};
export type WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee$key = {
  readonly " $data"?: WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetEmployeeScheduleShiftsEmployeeNamePanel_employee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "e6db5d96cb00112dd6ab0797118c2df6";

export default node;
